import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const CommissionSettingsTab = ({ 
  register, 
  errors, 
  watch, 
  setValue, 
  inputClassName 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-3">
      <div className="px-6 py-4  from-blue-50 to-indigo-50 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <UserGroupIcon className="h-6 w-6 mr-2 text-[#009efb]" />
          Commission Settings
        </h2>
      </div>
      <div className="p-6 space-y-6">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center">
            
            <input
              type="checkbox"
              {...register('is_pays_commission')}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              value={watch('is_pays_commission') || ''}
            />
            <span className="ml-3 text-sm font-medium text-blue-900">Pays Commission</span>
          </div>
        </div>

        {watch('is_pays_commission') && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700">Fixed Commission</label>
              <input
                type="number"
                {...register('fixed_commission')}
                className={`${inputClassName} ${
                  errors.fixed_commission ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                }`}
                placeholder="0.00"
              />
              {errors.fixed_commission && (
                <p className="mt-1 text-sm text-red-600">{errors.fixed_commission.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Percentage Commission</label>
              <input
                type="number"
                {...register('percentage_commission')}
                className={`${inputClassName} ${
                  errors.percentage_commission ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                }`}
                placeholder="0.00"
              />
              {errors.percentage_commission && (
                <p className="mt-1 text-sm text-red-600">{errors.percentage_commission.message}</p>
              )}
            </div>
          </div>
        )}

        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('is_pays_bonus')}
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
              value={watch('is_pays_bonus') || ''}
            />
            <span className="ml-3 text-sm font-medium text-green-900">Pays Bonus</span>
          </div>
        </div>

        {watch('is_pays_bonus') && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700">Fixed Bonus</label>
              <input
                type="number"
                {...register('fixed_bonus')}
                className={`${inputClassName} ${
                  errors.fixed_bonus ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                }`}
                placeholder="0.00"
              />
              {errors.fixed_bonus && (
                <p className="mt-1 text-sm text-red-600">{errors.fixed_bonus.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Percentage Bonus</label>
              <input
                type="number"
                {...register('percentage_bonus')}
                className={`${inputClassName} ${
                  errors.percentage_bonus ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                }`}
                placeholder="0.00"
              />
              {errors.percentage_bonus && (
                <p className="mt-1 text-sm text-red-600">{errors.percentage_bonus.message}</p>
              )}
            </div>
          </div>
        )}

        <div>
          <label className="block text-sm font-medium text-gray-700">Pays Hours</label>
          <input
            type="time"
            {...register('pays_hours')}
            className={`${inputClassName} ${
              errors.pays_hours ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
            }`}
            
          />
          {errors.pays_hours && (
            <p className="mt-1 text-sm text-red-600">{errors.pays_hours.message}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommissionSettingsTab; 